import { forwardRef } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_BUTTON_CLASS,
  INPUT_GROUP_BUTTON_DEFAULTS,
  INPUT_GROUP_BUTTON_SIZE_CLASS_MAP,
  TInputGroupButtonProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";
import {
  BUTTON_VARIANT_CLASS_MAP,
} from "@/ui/components/primitives/Button/Button.config";

export const InputGroupButton = forwardRef<HTMLButtonElement, TInputGroupButtonProps>(
  (
    {
      className,
      variant = INPUT_GROUP_BUTTON_DEFAULTS.variant,
      size = INPUT_GROUP_BUTTON_DEFAULTS.size,
      type = "button",
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      ref={ref}
      type={type}
      data-component="InputGroupButton"
      className={cn(
        INPUT_GROUP_BUTTON_CLASS,
        BUTTON_VARIANT_CLASS_MAP[variant],
        INPUT_GROUP_BUTTON_SIZE_CLASS_MAP[size],
        className,
      )}
    />
  ),
);

InputGroupButton.displayName = "InputGroupButton";
